import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';

import { GET_BOOKING_DETAILS_EMPTY } from '../../../../../../../../../store/actions';
import { Constant } from '../../../../../../../../Helpers/constant';
import CardViewActiveImg from './../../../../../../../../../assets/custom/card-view-active.png';
import CardViewImg from './../../../../../../../../../assets/custom/card-view.png';
import TabularViewActiveImg from './../../../../../../../../../assets/custom/tabular-view-active.png';
import TabularViewImg from './../../../../../../../../../assets/custom/tabular-view.png';
import CardView from './CardView';
import TabularView from './TabularView';

const DataViews = ({
  data,
  titleText,
  updateURLParams,
  skip,
  limit,
  setCurrentSelectedBooking,
  selectedBooking,
  setCurrentActiveBookingAction,
  bookingType = '',
  appliedName = '',
  isMultiSelectable = false,
  setIsMultiSelectable = null,
  shouldHaveClearSelection = false,
  setShouldHaveClearSelection,
  filterSubmitHandler,
  currentlyAppliedFilters,
  assignedToMeFilter,
  setAssignedToMeFilter,
  secondaryFiltersList,
}) => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATE ---------------------------- */
  const [isTabularView, setIsTabularView] = useState(
    Constant?.userTypes?.VENDOR_USER_V2 === parseInt(localStorage.getItem('userType')) ? false : true,
  );

  useEffect(() => {
    if (data?.result?.length > 0 && Constant?.userTypes?.VENDOR_USER_V2 === parseInt(localStorage.getItem('userType'))) {
      if (
        data?.result?.[0]?.bookingType === `airport_transfers` &&
        (data?.result?.[0]?.actions?.includes('complete_booking') || data?.result?.[0]?.actions?.includes('vendor_accept'))
      ) {
        setIsTabularView(true);
        setIsMultiSelectable(true);
      } else {
        // setIsTabularView(false);
        setIsMultiSelectable(false);
      }
    }
  }, [data?.result]);

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const handleRowsPerPageChange = newRowsPerPage => {
    updateURLParams({ skip: 1, limit: newRowsPerPage });
  };

  const paginationHandler = pageNumber => {
    updateURLParams({ skip: pageNumber + 1, limit: limit });
  };

  const toggleView = () => {
    setIsTabularView(!isTabularView);
    setCurrentSelectedBooking(null);
    setCurrentActiveBookingAction(null);

    setShouldHaveClearSelection(true);
    setTimeout(() => {
      setShouldHaveClearSelection(false);
    }, 1000);

    updateURLParams({ skip: 1, limit: limit });
    dispatch({
      type: GET_BOOKING_DETAILS_EMPTY,
    });
  };

  const userType = parseInt(localStorage.getItem('userType'));

  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex justify-content-end">
              <h4 className="card-title mb-0 flex-grow-1 custom-card-title"> {titleText} </h4>

              <div className="d-flex gap-3">
                {isTabularView && (
                  <div className="d-flex gap-2">
                    <>
                      {data?.result?.[0]?.actions?.includes('create_airport') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_airport')} color="primary">
                          + Create Airport
                        </Button>
                      )}

                      {selectedBooking?.length === 1 && data?.result?.[0]?.actions?.includes('update_airport') && (
                        <Button
                          className="customized-btn d-flex align-items-center gap-1"
                          onClick={() => setCurrentActiveBookingAction('update_airport')}
                          color="primary"
                        >
                          <i className="ri-edit-line"></i>
                          <span>Edit Details</span>
                        </Button>
                      )}

                      {data?.result?.[0]?.actions?.includes('create_zone') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_zone')} color="primary">
                          + Create Zone
                        </Button>
                      )}

                      {selectedBooking?.length === 1 && data?.result?.[0]?.actions?.includes('update_zone') && (
                        <Button
                          className="customized-btn d-flex align-items-center gap-1"
                          onClick={() => setCurrentActiveBookingAction('update_zone')}
                          color="primary"
                        >
                          <i className="ri-edit-line"></i>
                          <span>Edit Details</span>
                        </Button>
                      )}

                      {data?.result?.[0]?.actions?.includes('create_client') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_client')} color="primary">
                          + Create Client
                        </Button>
                      )}

                      {selectedBooking?.length === 1 && data?.result?.[0]?.actions?.includes('update_client') && (
                        <Button
                          className="customized-btn d-flex align-items-center gap-1"
                          onClick={() => setCurrentActiveBookingAction('update_client')}
                          color="primary"
                        >
                          <i className="ri-edit-line"></i>
                          <span>Edit Details</span>
                        </Button>
                      )}

                      {data?.result?.[0]?.actions?.includes('create_vendor') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_vendor')} color="primary">
                          + Create Vendor
                        </Button>
                      )}

                      {selectedBooking?.length === 1 && data?.result?.[0]?.actions?.includes('update_vendor') && (
                        <Button
                          className="customized-btn d-flex align-items-center gap-1"
                          onClick={() => setCurrentActiveBookingAction('update_vendor')}
                          color="primary"
                        >
                          <i className="ri-edit-line"></i>
                          <span>Edit Details</span>
                        </Button>
                      )}
                    </>
                  </div>
                )}

                {!isTabularView && (
                  <div className="d-flex gap-2">
                    <>
                      {data?.result?.[0]?.actions?.includes('create_airport') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_airport')} color="primary">
                          + Create Airport
                        </Button>
                      )}

                      {data?.result?.[0]?.actions?.includes('create_zone') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_zone')} color="primary">
                          + Create Zone
                        </Button>
                      )}

                      {data?.result?.[0]?.actions?.includes('create_client') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_client')} color="primary">
                          + Create Client
                        </Button>
                      )}

                      {data?.result?.[0]?.actions?.includes('create_vendor') && (
                        <Button className="btn btn-success" onClick={() => setCurrentActiveBookingAction('create_vendor')} color="primary">
                          + Create Vendor
                        </Button>
                      )}
                    </>
                  </div>
                )}

                <div className="d-flex gap-2 align-items-center">
                  {isTabularView ? (
                    <img src={CardViewImg} className="view-img" onClick={toggleView} />
                  ) : (
                    <img src={CardViewActiveImg} className="view-img" onClick={toggleView} />
                  )}
                  {isTabularView ? (
                    <img src={TabularViewActiveImg} className="view-img" onClick={toggleView} />
                  ) : (
                    <img src={TabularViewImg} className="view-img" onClick={toggleView} />
                  )}
                </div>
              </div>
            </CardHeader>

            <CardBody
              style={{
                zIndex: 0,
              }}
            >
              {isTabularView ? (
                <TabularView
                  data={data?.result}
                  schema={data?.schema?.tabularView}
                  totalCount={data?.totalCount}
                  skip={skip}
                  limit={limit}
                  handleRowsPerPageChange={handleRowsPerPageChange}
                  handlePageChange={paginationHandler}
                  setCurrentSelectedBooking={setCurrentSelectedBooking}
                  selectedBooking={selectedBooking}
                  isTableDisplay={true}
                  bookingType={bookingType}
                  appliedName={appliedName}
                  isMultiSelectable={isMultiSelectable}
                  shouldHaveClearSelection={shouldHaveClearSelection}
                />
              ) : (
                <>
                  <CardView
                    data={data?.result}
                    schema={data?.schema?.cardView}
                    isMultiSelectable={isMultiSelectable}
                    currentSelectedBooking={selectedBooking}
                    setCurrentSelectedBooking={setCurrentSelectedBooking}
                    setCurrentActiveBookingAction={setCurrentActiveBookingAction}
                  />
                  <TabularView
                    data={data?.result}
                    schema={data?.schema?.tabularView}
                    totalCount={data?.totalCount}
                    skip={skip}
                    limit={limit}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    handlePageChange={paginationHandler}
                    setCurrentSelectedBooking={setCurrentSelectedBooking}
                    isTableDisplay={(data?.result?.length ?? 0) === 0 ? true : false}
                    bookingType={bookingType}
                    isMultiSelectable={isMultiSelectable}
                    shouldHaveClearSelection={shouldHaveClearSelection}
                  />
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DataViews;
